import { createReduxMiddleware } from '@cx/analytics'
import { compose, createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers/root-reducer'
import IS_CLIENT from '../utils/is-client'
import analyticsTracker from '../utils/analytics-tracker'
import satellite from './middleware/satellite'

const analyticsMiddleware = []
if (IS_CLIENT) {
  analyticsMiddleware.push(...createReduxMiddleware(analyticsTracker))
  analyticsMiddleware.push(satellite)
}

export default (initialState, fetchMethod) => {
  const enhancer = compose(
    applyMiddleware(...[thunk.withExtraArgument(fetchMethod), ...analyticsMiddleware]),
    IS_CLIENT && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f
  )

  return createStore(rootReducer, initialState, enhancer)
}
